var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 14.3667V6.84326H2.5V14.3667H11.5ZM11.5 5.3667C11.8984 5.3667 12.25 5.51904 12.5547 5.82373C12.8594 6.10498 13.0117 6.44482 13.0117 6.84326V14.3667C13.0117 14.7651 12.8594 15.1167 12.5547 15.4214C12.25 15.7026 11.8984 15.8433 11.5 15.8433H2.5C2.10156 15.8433 1.75 15.7026 1.44531 15.4214C1.14062 15.1167 0.988281 14.7651 0.988281 14.3667V6.84326C0.988281 6.44482 1.14062 6.10498 1.44531 5.82373C1.75 5.51904 2.10156 5.3667 2.5 5.3667H9.32031V3.85498C9.32031 3.22217 9.08594 2.68311 8.61719 2.23779C8.17188 1.76904 7.63281 1.53467 7 1.53467C6.36719 1.53467 5.81641 1.76904 5.34766 2.23779C4.90234 2.68311 4.67969 3.22217 4.67969 3.85498H3.23828C3.23828 2.82373 3.60156 1.94482 4.32812 1.21826C5.07812 0.468262 5.96875 0.0932617 7 0.0932617C8.03125 0.0932617 8.91016 0.468262 9.63672 1.21826C10.3867 1.94482 10.7617 2.82373 10.7617 3.85498V5.3667H11.5ZM8.05469 11.6597C7.75 11.9644 7.39844 12.1167 7 12.1167C6.60156 12.1167 6.25 11.9644 5.94531 11.6597C5.64062 11.355 5.48828 11.0034 5.48828 10.605C5.48828 10.2065 5.64062 9.85498 5.94531 9.55029C6.25 9.24561 6.60156 9.09326 7 9.09326C7.39844 9.09326 7.75 9.24561 8.05469 9.55029C8.35938 9.85498 8.51172 10.2065 8.51172 10.605C8.51172 11.0034 8.35938 11.355 8.05469 11.6597Z",
    fill: "black",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordIcon);
export default __webpack_public_path__ + "static/media/passwordIcon.a39aba9fc5ff4d40aa0b570578f9fef7.svg";
export { ForwardRef as ReactComponent };